// import { BaseApi } from "../../../services/base-api";
import { CustomAxiosRequestConfig } from "../../../interceptors/axios/custom-axios";
import { BaseApi } from "./base-api";
import { ENDPOINTS } from "./endpoint";


export interface GetDetailsPayload {
  searchValue: string;
  searchType: string;
  page?: number;
  pageSize?: number;
}
export interface GetParamsPayload {
  searchParam: string;
  searchType: string;
}
export interface GetDetailsResponse {
  data: any;
}
export interface GetParamsResponse {
  paramValues(paramValues: any): unknown;
  data: any;
}
export interface GetCustomerSubscriptionPayload {
  customerId: string;
}
export interface GetCustomerDetailsPayload {
  customerNumber: string;
  page?: number;
  pageSize?: number;
  aircraftTailNumber?: string;
  aircraftSerialNumber?: string;
}
export interface SendDocumentsPayload {
  productName: string;
  emails: string[];
  documents: { fileName: string }[];
}
export interface PrepareZipPayload {
  token: string[];
}
export interface SingleFileDownloadPayload {
  fileName: string;
  userId?: string;
  itemName?: string;
  itemDescription?: string;
  fileType?: 'EXT' | 'ZIP';
  source?: string;
  customerNumber?: string;
}
export interface GetGuestTokenDetailsPayload {
  token: string;
validateToken?: string;
}
export interface GetGuestProductsPayload {
  productIds: number[];
}
export const getGuestTokenDetails = async (payload: GetGuestTokenDetailsPayload): Promise<any> => {
  try {
    const response = await BaseApi.baseApiCon.post(ENDPOINTS.getGuestTokenDetails, payload);
    return response.data.data.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.errorMessage||error?.response?.data?.errorDescription );
  }
};
export const getGuestProducts = async (payload: GetGuestProductsPayload): Promise<any> => {
  try {
    const response = await BaseApi.baseApiCon.post(ENDPOINTS.getGuestProducts, payload);
    return response.data.data.data;
  } catch (error: any) {
    console.error('Error fetching guest products:', error?.response?.data);
    throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.errorDescription );
  }
};
export const getDetails = async (payload: GetDetailsPayload): Promise<GetDetailsResponse> => {
  try {
    const params: any = {};
    if (payload.page) params.page = payload.page;
    if (payload.pageSize) params.pageSize = payload.pageSize;
    
    const body = {
      searchValue: payload.searchValue,
      searchType: payload.searchType
    };
    
    const response = await BaseApi.baseApiCon.post(ENDPOINTS.getDetails, body, { params });

    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.errorDescription);
  }
};
export const getCustomerSubscriptions = async (payload: GetCustomerSubscriptionPayload): Promise<GetDetailsResponse> => {
  try {
    const response = await BaseApi.baseApiCon.post(ENDPOINTS.getSubscriptions + '?page=1&pageSize=10', payload);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.errorDescription);
  }
};
export const getCustomerDetails = async (payload: GetCustomerDetailsPayload): Promise<GetDetailsResponse> => {
  try {
    const params: any = {};
    if (payload.page) params.page = payload.page;
    if (payload.pageSize) params.pageSize = payload.pageSize;
    
    const body: any = {
      customerNumber: payload.customerNumber
    };
    
    if (payload.aircraftTailNumber) {
      body.aircraftTailNumber = payload.aircraftTailNumber;
    }
    if (payload.aircraftSerialNumber) {
      body.aircraftSerialNumber = payload.aircraftSerialNumber;
    }
    
    const response = await BaseApi.baseApiCon.post(ENDPOINTS.getCustomerDetails, body, { params });
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.errorDescription);
  }
};
export const getAdminSearchParams = async (payload: GetParamsPayload): Promise<GetParamsResponse> => {
  try {
    const response = await BaseApi.baseApiCon.post(ENDPOINTS.getAdminSearchParams, payload);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.errorDescription);
  }
};
export const getAdminProducts = async (payload?: { categoryHeading: string, subcategory?: string }): Promise<any> => {
  try {
    const response = await BaseApi.baseApiCon.post(ENDPOINTS.getAdminProducts, payload || {});

    return response.data.data.content;
  } catch (error: any) {
    throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.errorDescription);
  }
};
export const getAdminProductsCategory = async (): Promise<any> => {
  try {
    const response = await BaseApi.baseApiCon.post(ENDPOINTS.getAdminProductsCategory,);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.errorDescription);
  }
};
export const sendDocuments = async (payload: SendDocumentsPayload): Promise<any> => {
  try {
    const response = await BaseApi.baseApiCon.post(ENDPOINTS.sendDocuments, payload,{ requiresCSRF: true } as CustomAxiosRequestConfig);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.errorDescription);
  }
};

export const prepareZip = async (
  payload: PrepareZipPayload,
  onDownloadProgress: (progressEvent: any) => void = () => { }
): Promise<Blob> => {
  try {
    const response = await BaseApi.baseApiCon.post(ENDPOINTS.prepareZip, payload, {
      responseType: 'blob' as any,
      timeout: 0,
      onDownloadProgress,
    });
    return response.data as Blob;
  } catch (error: any) {
    throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.errorDescription);
  }
};

export const singleFileDownload = async (
  payload: SingleFileDownloadPayload,
  onDownloadProgress: (progressEvent: any) => void = () => { },
  signal?: AbortSignal
): Promise<Blob> => {
  try {
    const response = await BaseApi.baseApiCon.post(ENDPOINTS.singleFileDownload, payload, {
      responseType: 'blob' as any,
      timeout: 0,
      onDownloadProgress,
      signal,
    });
    return response.data as Blob;
  } catch (error: any) {
    throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.errorDescription||error?.message);
  }
};